import React, { useEffect, useState } from 'react';

const PlayerRank = ({ userId }: { userId: string | null }) => {
    const [rank, setRank] = useState(null);

    useEffect(() => {
        if (!userId) return
        fetch(`/api/panda/getPlayerRank?userId=${userId}`)
            .then((response) => response.json())
            .then((data) => setRank(data.rank))
            .catch((error) => console.error('Error:', error));
    }, [userId]);

    return <div className='text-yellow-100 text-xs mb-2'>Your rank: {rank}</div>;
};

export default PlayerRank;
